import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import { appConfig } from "../../../utils/app.config";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";

import { app, authentication } from "@microsoft/teams-js";

interface LoginProps {
  children: React.ReactNode;
}

const Login: React.FC<LoginProps> = ({ children }: any) => {
  //const navigate = useNavigate();
  const [checkLogin, setCheckLogin] = useState<boolean>(false);

  const location = useLocation();
  const encodedState = btoa(
    JSON.stringify({ location: window.location.href, bot: "B001" })
  );
  const randomKey = CryptoJS.lib.WordArray.random(16);
  const stateCode = randomKey.toString(CryptoJS.enc.Hex);
  const obj = {
    code: stateCode,
    state: encodedState,
  };
  sessionStorage.setItem("state_code", JSON.stringify(obj));

  const loginUrl = `${appConfig.loginUrl}&state=${encodeURIComponent(
    stateCode
  )}`;

  // useEffect(() => {
  //   // Function to check the token's validity
  //   const checkToken = async () => {
  //     const token = sessionStorage.getItem(appConfig.loginTokenName);
  //     if (!token) {
  //       //navigate(appConfig.loginUrl);
  //       // window.location.href = loginUrl;
  //       try {
  //         await app.initialize();
  //         authentication.authenticate({
  //           url: loginUrl,
  //           width: 600,
  //           height: 535
  //         });
  //       } catch (error) {
  //         //browser login
  //         window.location.href = loginUrl;
  //       }
  //     } else {
  //       try {
  //         const decodedToken = jwtDecode(token) as any;
  //         const currentTime = Date.now() / 1000; // Get current time in seconds

  //         if (decodedToken.exp < currentTime) {
  //           // Token expired, navigate to login
  //           sessionStorage.removeItem(appConfig.loginTokenName);
  //           window.location.href = loginUrl;
  //         } else {
  //           setCheckLogin(true);
  //         }
  //       } catch (error) {
  //         // If token is invalid, navigate to login
  //         sessionStorage.removeItem(appConfig.loginTokenName);
  //         window.location.href = loginUrl;
  //       }
  //     }
  //   };
  //   checkToken();
  // }, [checkLogin]);

  //==========added by shivam seth for teams sso=======
  useEffect(() => {
    const checkToken = async () => {
      const token = sessionStorage.getItem(appConfig.loginTokenName);
      //  STEP 1 if token already exist validate it
      if (token) {
        try {
          const decodedToken = jwtDecode(token) as any;
          const currentTime = Date.now() / 1000;

          if (decodedToken.exp < currentTime) {
            sessionStorage.removeItem(appConfig.loginTokenName);
          } else {
            setCheckLogin(true);
            return;
          }
        } catch {
          sessionStorage.removeItem(appConfig.loginTokenName);
        }
      }
      //  STEP 2 Teams environment detecting

      try {
        await app.initialize();

        console.log("Running inside Teams");
        //  STEP 3 getting Teams SSO token

        authentication.getAuthToken({
          successCallback: async (teamsToken) => {
            console.log("Teams SSO token received");
            //  STEP 4 sending token to Backend
            const response = await fetch("/api/teams-login", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                token: teamsToken,
              }),
            });

            const data = await response.json();
            //  STEP 5 Backend JWT storing
            sessionStorage.setItem(appConfig.loginTokenName, data.jwt);

            setCheckLogin(true);
          },

          failureCallback: (error) => {
            console.log("Teams SSO failed:", error);
            //  STEP 6 if teams sso fails fallback login
            window.location.href = loginUrl;
          },
        });
      } catch {
        //  STEP 7 if not in teams normal browser login
        console.log("Running outside Teams");

        window.location.href = loginUrl;
      }
    };

    checkToken();
  }, [checkLogin]);

  if (checkLogin) {
    return <>{children}</>;
  }
  return null;
};

export default Login;
